<template>
  <!-- App.vue -->

  <v-app>
    <v-app-bar app color="primary">    
      <v-toolbar-title><v-img max-width="150" src="@/assets/logo.png"></v-img></v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="font-weight-bold white--text">{{ user.usernameLogin }} </span> 
      <v-btn dark x-large icon @click="logout">             
         <v-icon large>  mdi-exit-to-app </v-icon>      
      </v-btn>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>       
        <div class="text-center"> 
           <v-chip color="primary font-weight-bold">
           Situación: {{ user.statusDebt }} | Lote: {{ user.legalStatus }}
        </v-chip>
         
        </div>
        <div style="margin: 25px 10px 75px 10px">
          <!-- If using vue-router -->
          <router-view></router-view>
        </div>
      </v-container>
    </v-main>

    <v-footer app style="background-color: blue;">
      <v-bottom-navigation fixed grow background-color="primary" color="white" v-model="value" style="height:76px">
        <div v-for="(bottomnav, i) in bottomnav" :key="i">
          <v-btn fab x-large icon link dark :to="{ name: bottomnav.name }" style="padding: 12px 12px 12px 12px">
            <v-icon v-text="bottomnav.icon"></v-icon>
          </v-btn>
        </div>
      </v-bottom-navigation>
    </v-footer>
  </v-app>
</template>

<script>
import notificationService from '@/services/notifications';

export default {
  data() {
    return {
    user: null,
    bottomnav: [
      {
        icon: 'mdi-home-circle',
        name: 'dashboardUser',
      }    
    ],
    leftnavbar: [
    /*  {
        name: 'debtors',
        title: 'Lista de deudores',
        icon: 'mdi-account-clock',
      }, 
      {
        name: 'cardsuser',
        title: 'Tarjetas domiciliadas',
        icon: 'mdi-credit-card-check-outline',
      }, */
      {
        name: 'events',
        title: 'Próximos eventos',
        icon: 'mdi-calendar-month-outline',
      },  
      {
        name: 'regulations',
        title: 'Reglamento',
        icon: 'mdi-script-text-outline',
      },
      {
        name: 'mytickets',
        title: 'Tickets',
        icon: 'mdi-ticket',
      },
    ],
    value: 'recent',
    drawer: false,
    group: null,
  }
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    },
  },
  created () {
    this.user = this.$store.getters['session/user'];
   console.log(JSON.parse(localStorage.getItem('user')));
    this.getNotifications();
  },
  methods: {
    logout() {
      this.$store.dispatch('session/logout');
    },
    getNotifications() {
      notificationService.fetch().then((response) => {
        this.$store.commit('resetMessages');
        response.data.forEach(item => {
          if (!item.readed && item.recipientId) {
            this.$store.commit('messages');
          }
        });
      });
    },
  },
};
</script>